// extracted by mini-css-extract-plugin
export default {"container":"Products_container__GJ0km","products":"Products_products__2xPQW","menu":"Products_menu__S1Mkl","list":"Products_list__aMfiV","product":"Products_product__jp8pO"};